import { ErrorBoundary } from '~/modules/errors/components/ErrorBoundary';

import { Router } from './router';

export function App() {
  return (
    <ErrorBoundary key="my-profile">
      <Router />
    </ErrorBoundary>
  );
}

App.displayName = 'ProfileApp';
